import React, { useContext, useRef } from "react";
import KeyInfo from "./keyInfo";
import { BannerContext } from '../../contexts/BannerDimensionsContext';
import { ObjectToHtml, CreateHash, base64ToBlob } from '../../helpers/formaterBanner';
import { Compress } from '../../helpers/fileManager';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import { GetBannerSize, convertBlobToBase64 } from '../../helpers/fileManager.js';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import NavigationIcon from '@mui/icons-material/Navigation';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import './index.css'

export default function Tooltip(props) {
  const refInputAsset = useRef(null);
  const refReduce = useRef(null);
  const refEnabled = useRef(null);
  const refProject = useRef(null);
  const refInputTop = useRef(null);
  const refInputLeft = useRef(null);
  const refInputScale = useRef(null);
  const refInputZindex = useRef(null);
  const { listaReplicas, replicaActive, setListaReplicas, assets, setAssets, master } = useContext(BannerContext);
  const show = props.activeElement && props.element === props.activeElement.id;
  const activeElement = props.activeElement;

  function changeValue(evt, type) {
    try {
      if (evt.key === "Enter" || evt.type === "blur") {
        var value = parseInt(evt.target.value);
        props.onClick(type, value);
      }
    } catch(error) {
    }
  }

  async function updateAsset(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      var img = new Image;
      img.onload = function() {
        const width = img.width;
        const height = img.height;
        const b64 = reader.result;
        convertB64(b64, width, height);
      };
      img.src = reader.result;
    };
    reader.onerror = function (error) {
      return null;
    };
  }
  
  function generateUUID() {
    const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0; // Número aleatório entre 0 e 15
        const v = c === 'x' ? r : (r & 0x3 | 0x8); // Garantir o bit específico para 'y'
        return v.toString(16); // Converter para hexadecimal
    });
  }

  async function convertB64(b64, width, height) {
    try {
      var copyReplicas = JSON.parse(JSON.stringify(listaReplicas));  
      var copyMaster = JSON.parse(JSON.stringify(master));
      var listAssets = JSON.parse(JSON.stringify(assets));
      try {
        if (!listAssets || listAssets.length === 0 || listAssets === null || listAssets === undefined || listAssets === "undefined") {
          listAssets = [];
          copyMaster.elements.forEach(element => {
            const index = listAssets.findIndex(obj => obj.uuid === element.properties.asset);
            if (index === -1) {
              if (element.properties.background) {
                listAssets.push({
                  uuid: element.properties.asset,
                  data: element.properties.background
                });
              } else if (element.properties.originalBackground) {
                listAssets.push({
                  uuid: element.properties.asset,
                  data: element.properties.originalBackground
                });
              } else if (element.properties.blob) {
                convertBlobToBase64(base64ToBlob(element.properties.blob)).then((b64) => {
                  listAssets.push({
                    uuid: element.properties.asset,
                    data: b64
                  });
                });
              }
            }
          });
    
          listaReplicas.forEach(replica => {
            replica.elements.forEach(element => {
              const index = listAssets.findIndex(obj => obj.uuid === element.properties.asset);
              if (index === -1) {
                if (element.properties.originalBackground) {
                  listAssets.push({
                    uuid: element.properties.asset,
                    data: element.properties.originalBackground
                  });
                } else if (element.properties.blob) {
                  convertBlobToBase64(base64ToBlob(element.properties.blob)).then((b64) => {
                    listAssets.push({
                      uuid: element.properties.asset,
                      data: b64
                    });
                  });
                } else if (element.properties.background) {
                  listAssets.push({
                    uuid: element.properties.asset,
                    data: element.properties.background
                  });
                }
              }
            });
          })
        }
      } catch (error) {
        console.log('Error ao processar assets com lista vazia', error);
      }


      const uuid = generateUUID();
      listAssets.push({
        uuid: uuid,
        data: b64
      })

      for (var i = 0; i < copyReplicas.length; i++) {
        const replica = copyReplicas[i];
        if (`${replica.width}x${replica.height}` === replicaActive) {
          replica.hash = CreateHash(replica);
          const optimize = replica.optimize;
          for (var j = 0; j < replica.elements.length; j++) {
            const element = replica.elements[j];
            if (element.id === activeElement.id) {
              try {
                element.properties.asset = uuid;
                element.properties.width = width;
                element.properties.height = height;
                element.properties.originalBackground = b64;
                const blob = base64ToBlob(b64);
                const blobUrl = URL.createObjectURL(blob);
                element.properties.blob = blobUrl;
                 var originalBG = element.properties.originalBackground.replaceAll("'", "");
                 let b64_op = originalBG;
                 if (optimize < 100) {
                   b64_op = element.properties.background = await Compress(originalBG, replica.optimize);
                 }
                 element.properties.originalBackground = b64;
                 element.properties.background = b64_op;
                 if (optimize < 100) {
                   element.properties.background = await Compress(originalBG, optimize);
                 } else {
                   element.properties.background = originalBG;
                 }
              } catch (error) { console.log(error) }
            }
          }
        }
        replica.html = ObjectToHtml(replica, true);
        const html = ObjectToHtml(replica);
        replica.size = GetBannerSize(html);
        setAssets(listAssets);
      }
      setListaReplicas(copyReplicas);
    } catch (error) { console.log(error) }
  } 


  try {
    refReduce.current.checked = activeElement.reduce;
    refEnabled.current.checked = activeElement.enabled;
    refProject.current.checked = activeElement.project;
    refInputTop.current.value =  activeElement.properties.top;
    refInputLeft.current.value =  activeElement.properties.left;
    refInputScale.current.value =  activeElement.properties.scale;
    refInputZindex.current.value =  activeElement.properties.zIndex;
  } catch {}

  function handlePosition(position) {
    props.onClick(position, "");
  }

  if (show) {
    return (
      <div className="root-tooltip">
        <div className="root-tooltip-prop">
          <div style={{display: 'flex', flexDirection: 'row', marginTop: '10px'}}>
            <div style={{display: 'flex', flexDirection: 'column', width: '300px', marginRight: '30px', textAlign: 'center'}}>
              <div className="tooltip-properties">
                <div>
                  <VerticalAlignTopIcon style={{margin: '0 7px -6px 0', color: '#FFFFFF'}}/>
                  <input
                  ref={refInputTop}
                  style={{width: '50px', height: '24px', textAlign: 'center', borderRadius: '4px', border: 'none'}}
                  placeholder={activeElement.properties.top} 
                  onKeyDown={(evt) => changeValue(evt, "top")}
                  onBlur={(evt) => changeValue(evt, "top")}
                  />
                </div>
                <div>
                  <VerticalAlignTopIcon style={{transform: 'rotate(-90deg)', margin: '0 7px -7px 0', color: '#FFFFFF'}}/>
                  <input
                  ref={refInputLeft}
                  style={{width: '50px', height: '24px', borderRadius: '4px', border: 'none', textAlign: 'center'}}
                  placeholder={activeElement.properties.left} 
                  onKeyDown={(evt) => changeValue(evt, "left")}
                  onBlur={(evt) => changeValue(evt, "left")}
                />
                </div>
                <div>
                  <ZoomOutMapIcon style={{margin: '0 7px -7px 0', color: '#FFFFFF'}}/>
                  <input
                  ref={refInputScale}
                  style={{width: '50px', height: '24px', borderRadius: '4px', border: 'none', textAlign: 'center'}}
                  placeholder={activeElement.properties.scale} 
                  onKeyDown={(evt) => changeValue(evt, "scale")}
                  onBlur={(evt) => changeValue(evt, "scale")}
                  />
                </div>
                <div>
                  <OpenInNewIcon style={{margin: '0 7px -7px 0', color: '#FFFFFF'}}/>
                  <input
                  ref={refInputZindex}
                  style={{width: '50px', height: '24px', borderRadius: '4px', border: 'none', textAlign: 'center'}}
                  placeholder={activeElement.properties.zIndex}
                  onKeyDown={(evt) => changeValue(evt, "zindex")}
                  onBlur={(evt) => changeValue(evt, "zindex")}
                />
                </div>
              </div>
              <div style={{margin: '-120px 0 0 120px', width: '100px', height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative'}}>
                  <NavigationIcon onClick={() => handlePosition("align_top")} className="button-arrow" style={{ transform: 'rotate(0deg) scale(1.5)', top: '0px' }}/>
                  <NavigationIcon onClick={() => handlePosition("align_right")} className="button-arrow" style={{ transform: 'rotate(90deg) scale(1.5)', right: '0px'}}/>
                  <NavigationIcon onClick={() => handlePosition("align_down")} className="button-arrow" style={{ transform: 'rotate(180deg) scale(1.5)', bottom: '0px' }}/>
                  <NavigationIcon onClick={() => handlePosition("align_left")} className="button-arrow" style={{ transform: 'rotate(270deg) scale(1.5)', left: '0px' }}/>
                  {/* <AlignHorizontalCenterIcon onClick={() => handlePosition("align_horizontal")} className="button-arrow" style={{ top: 9, left: 143 }}/>
                  <AlignVerticalCenterIcon onClick={() => handlePosition("align_vertical")} className="button-arrow" style={{ top: 11, left: 59 }}/> */}
                  <ControlCameraIcon onClick={() => handlePosition("align_center")} className="button-arrow" style={{ transform: 'rotate(45deg) scale(1.5)' }}/>
                </div>
                
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '40px 0 0 0'}}>
                  <div>
                    <input
                      ref={refEnabled}
                      defaultChecked={activeElement.enabled}
                      style={{accentColor: '#68498C', outline: '1px solid white', outlineRadius: '10px'}}
                      type='checkbox'
                      onChange={() => props.onClick('enabled', '')}>
                    </input>
                    <span style={{fontSize: '16px', fontWeight: 'normal', margin: '0 0 0 5px'}}>
                      Ativar
                    </span>
                  </div>
                  <div>
                    <input
                      ref={refProject}
                      defaultChecked={activeElement.project}
                      style={{accentColor: '#68498C', outline: '1px solid white', outlineRadius: '10px'}}
                      type='checkbox'
                      onChange={() => props.onClick('project', '')}>
                    </input>
                    <span style={{fontSize: '16px', fontWeight: 'normal', margin: '0 0 0 5px'}}>
                      Projetar
                    </span>
                  </div>
                  {/* <div>
                    <input
                      ref={refReduce}
                      defaultChecked={activeElement.reduce}
                      style={{accentColor: '#68498C', outline: '1px solid white', outlineRadius: '10px'}}
                      type='checkbox'
                      onChange={() => props.onClick('reduce', '')}>
                    </input>
                    <span style={{fontSize: '16px', fontWeight: 'normal', margin: '0 0 0 5px'}}>
                      Remover background-size
                    </span>
                  </div> */}
                </div>
                <div
                  className="button-change-asset"
                  style={{backgroundColor: '#68498C', border: '1px solid white', width: '93px', height:'24px', alignSelf: 'flex-start', margin: '10px 0 0 2px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                  onClick={() => refInputAsset.current.click()}
                  >
                  <span style={{color: 'white', fontSize: '12px'}}>Trocar Asset</span>               
                  <input
                    onChange={(e) => updateAsset(e.target.files[0])}
                    ref={refInputAsset}
                    accept=".jpg, .png, .jpeg, .bmp, .tif, .tiff|image/*"
                    type='file'
                    style={{display: 'none'}}
                  />
                </div>
              
            </div>
          </div>
        </div>
        <div className="tooltip-shortcut-root" style={{display: 'none'}}>
          <span style={{color: '#6E4590'}}>
            Atalho para os controles
          </span>
          <div className='tooltip-shortcut'>
            <KeyInfo infoKey="Q" text="Elemento anterior do stage"></KeyInfo>
            <KeyInfo infoKey="W" text="Mover elemento para cima"></KeyInfo>
            <KeyInfo infoKey="E" text="Próximo elemento do stage"></KeyInfo>
            <KeyInfo infoKey="A" text="Mover elemento para a esquerda"></KeyInfo>
            <KeyInfo infoKey="S" text="Mover elemento para baixo"></KeyInfo>
            <KeyInfo infoKey="D" text="Mover elemento para a direita"></KeyInfo>
            <KeyInfo infoKey="-" text="Diminuir elemento"></KeyInfo>
            <KeyInfo infoKey="+" text="Aumentar elemento"></KeyInfo>
          </div>
        </div>
      </div>
    )  

  } else {
    return <></>
  }
}
